'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HealthCheck = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HealthCheck = exports.HealthCheck = {
    fetchHealthCheckData: function fetchHealthCheckData() {
        return new _promise2.default(function (resolve, reject) {
            var request = _superagent2.default.get('/healthcheck');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/healthcheck.js
// module id = aIJS
// module chunks = 60